import {AxiosError} from 'axios';
import axiosClient from '../axiosClient';
import {useCustomQuery} from '../utils/useCustomQuery';
import {GET_NON_NATIONAL_SIBLING_EXAM_LEVEL} from '../../constants/apiUrls';
import {IOptionType} from '../../api/candidate/exam/model';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================

export interface GetSiblingExamResponse {
}

// =============================================================================
// Query
// =============================================================================
interface Input {
  onSuccess?: (data: IOptionType[]) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const useGetSiblingExamLevel = ({onSuccess, onError}: Input) => {
  const getSiblingExamLevel = async () => {
    const res = await axiosClient.get<IOptionType[]>(GET_NON_NATIONAL_SIBLING_EXAM_LEVEL);
    return res.data;
  };
  return useCustomQuery([GET_NON_NATIONAL_SIBLING_EXAM_LEVEL], getSiblingExamLevel, {
    onSuccess,
    onError,
  });
};
